import moment from "moment";
import { CalendarDrawerContent, CalendarState, ExtraPage } from "burde";
import { D3Selection } from "./draw-calendar";
import {
    CalendarSizeDimensions,
    Page,
    PageSelector,
    SvgId,
} from "svg/constants";
import drawDynamicExtraPage from "./draw-dynamic-extra-page";

const getClass = (pageNumber: number) => {
    let page = Page.Odd;
    if (pageNumber % 2 > 0) {
        page = Page.Even;
    }

    return (page === Page.Odd ? PageSelector.Left : PageSelector.Right).replace(
        ".",
        "",
    );
};

const draw = (
    base: D3Selection,
    extraPageSvg: string,
    pageNumber: number,
    calendarDimensions: CalendarSizeDimensions,
) => {
    const containerId = `svgContainer${pageNumber}`;

    const container = base
        .append("div")
        .attr("id", containerId)
        .attr("class", "svg-container");

    const svg = container
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true)
        .attr("id", `${SvgId}${pageNumber}`)
        .attr("xmlns", "http://www.w3.org/2000/svg");

    const content = svg
        .append("g")
        .classed(`main-content ${getClass(pageNumber)}`, true);

    content.append("g").html(extraPageSvg).classed("svg-content", true);

    content
        .select(".outerContent")
        .attr("height", calendarDimensions.contentHeightWithoutBleeds + 60)
        .attr("width", calendarDimensions.contentWidthWithoutBleeds + 60);

    return svg;
};

const drawExtraPage = (
    base: D3Selection,
    extraPage: ExtraPage,
    pageNumber: number,
    calendarDimensions: CalendarSizeDimensions,
    calendar: CalendarState,
    Header_WeekNumberPrefix: string,
    calendarDrawerContent: CalendarDrawerContent,
) => {
    const leftSvg = draw(
        base,
        extraPage.endpoints.leftPage,
        pageNumber,
        calendarDimensions,
    );

    pageNumber += 1;

    const rightSvg = draw(
        base,
        extraPage.endpoints.rightPage,
        pageNumber,
        calendarDimensions,
    );

    if (extraPage.dynamicDates === true) {
        drawDynamicExtraPage(
            leftSvg,
            moment(calendar.startDate),
            calendarDrawerContent.metadata,
            calendar.culture,
            Header_WeekNumberPrefix,
        );

        drawDynamicExtraPage(
            rightSvg,
            moment(calendar.startDate),
            calendarDrawerContent.metadata,
            calendar.culture,
            Header_WeekNumberPrefix,
        );
    }
};

export { drawExtraPage };
